import { BaseService, Service } from "/@/cool";
@Service("shopFrozen")
class shopFrozen extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["page"] = prefix + "page";
	}
}
export default shopFrozen;
